const message = "Caracteres inválidos";
export const validations = {
  soloLetras: {
    value: /^[A-Za-zñáéíóúÑÁÉÍÓÚ]+$/i,
    message,
  },
  letrasYespacios: {
    value: /^[A-Za-zñáéíóúÑÁÉÍÓÚ\s]+$/i,
    message,
  },

  emails: {
    value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g,
    message,
  },
  soloNumeros: {
    value: /^[0-9]*$/,
    message,
  },
  numerosYespacios: {
    value: /^[0-9\s]*$/,
    message,
  },
  letrasNumerosEspaciosEspeciales: {
    value: /^[0-9A-Za-z/#.&,*+$%!?~`"';><\\[\]{}(_|)-ñáéíóúÑÁÉÍÓÚ\s]+$/i,
    message,
  },
  letrasNumerosEspacios: {
    value: /^[0-9A-Za-zñáéíóúÑÁÉÍÓÚ\s]+$/i,
    message,
  },
  letrasYnumeros: {
    value: /^[0-9A-Za-zñáéíóúÑÁÉÍÓÚ]+$/i,
    message,
  },
};
